import { useState, useEffect } from 'react';

/**
 * Hook personalizado para manejo del consentimiento de privacidad
 * Utiliza localStorage para persistir la aceptación del usuario
 */
export const usePrivacyConsent = () => {
  // Estado para controlar si el usuario ha dado su consentimiento
  const [hasConsent, setHasConsent] = useState(false);
  
  // Estado para controlar la visibilidad del modal
  const [showModal, setShowModal] = useState(false);

  // Efecto para cargar el estado de consentimiento desde localStorage al montar el componente
  useEffect(() => {
    const savedConsent = localStorage.getItem('privacyConsent');
    const consentValue = savedConsent === 'true';
    
    setHasConsent(consentValue);
    
    // NO mostrar el modal automáticamente
    // Solo se mostrará cuando el usuario intente enviar el formulario
  }, []);

  // Función para aceptar el consentimiento
  const acceptConsent = () => {
    localStorage.setItem('privacyConsent', 'true');
    setHasConsent(true);
    setShowModal(false);
  };

  // Función para rechazar el consentimiento
  const rejectConsent = () => {
    localStorage.setItem('privacyConsent', 'false');
    setHasConsent(false);
    setShowModal(false);
  };

  // Función para mostrar el modal cuando se requiera consentimiento
  const requireConsent = () => {
    if (!hasConsent) {
      setShowModal(true);
      return false;
    }
    return true;
  };

  return {
    hasConsent,
    showModal,
    setShowModal,
    acceptConsent,
    rejectConsent,
    requireConsent
  };
};
